import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import AudioLesson from '@/components/course/AudioLesson.vue'
  import TableLesson from '@/components/course/TableLesson.vue'
  import LessonSlideshow from '@/components/course/LessonSlideshow.vue'
  import AuthorAudioSection from '@/components/course/AuthorAudioSection.vue'
  import QuestionWithButtons from '@/components/common/QuestionWithButtons.vue'
  import LessonScript from '@/components/course/LessonScript.vue'
  import CourseApi from '@/services/api/CourseApi'
  import useCourse from '@/composables/useCourse'
  import useSegment from '@/composables/useSegment'
  import useGamification from '@/composables/useGamification'
  import VideoOrImageRenderer from '@/components/course/VideoOrImageRenderer.vue'
  import { EditorModule } from '@/store/modules/editor'
  import useEditor from '@/composables/useEditor'
  import DurationInput from '@/components/common/DurationInput.vue'
  import VideoTranscript from '@/components/course/VideoTranscript.vue'
  import LessonSlideshowEditor from '@/components/course/LessonSlideshowEditor.vue'
  import AudioLessonEditor from '@/components/course/AudioLessonEditor.vue'
  import EditDownloadableDownloadUrl from '@/components/editor/EditDownloadableDownloadUrl.vue'
  import EditLessonInCourseDownloadables from '@/components/editor/EditLessonInCourseDownloadables.vue'
  import AudioAuthor from '@/components/editor/AudioAuthor.vue'
  import { useRoute, useRouter } from 'vue-router/composables'
  import type { PropType } from 'vue'
  import type { Lesson, LessonDownloadable } from '@/services/interfaces/Course'
  import type { QuestionAnswer } from '@/services/interfaces/QuizQuestion'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LessonTypes',
  props: {
    currentLesson: {
      type: Object as PropType<Lesson>,
      required: true,
    },
    courseId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      required: true,
    },
    formatContent: {
      type: Boolean,
      default: false,
    },
    canEdit: Boolean,
  },
  emits: ['download-document'],
  setup(__props) {

const props = __props;

  
  
  const route = useRoute()
  const router = useRouter()
  const { quizId, completeALesson, lessonId, course, currentModule } = useCourse()
  const { lessonQuizCompleted } = useSegment()
  const { trackGamificationActivity } = useGamification()
  const { inEditorMode: editorMode, currentEditorLesson } = useEditor(route)

  const inEditorMode = computed(() => editorMode.value && props.canEdit)

  const quizQuestions = computed(() => {
    return props.currentLesson?.quiz?.questions ?? []
  })

  const lessonDownloadable = computed(() =>
    inEditorMode.value ? EditorModule.lessonDownloadable : props.currentLesson.downloadables,
  )

  const downloadTeaserImageUrl = computed(() => lessonDownloadable.value?.downloadTeaserImageUrl || '')

  const lessonDownloadableAuthorId = computed(() => lessonDownloadable.value?.audioAuthor?.id ?? '')

  const submitQuizAnswers = (answers: QuestionAnswer[]) => {
    CourseApi.postLessonQuizCompletion(props.courseId, props.moduleId, lessonId.value, answers, 'completed')
      .then((resp) => {
        lessonQuizCompleted(
          quizId.value,
          resp.passed,
          resp.completionId,
          props.courseId,
          course.value!.title,
          props.moduleId,
          currentModule.value.name,
        )
        if (resp.passed) {
          trackGamificationActivity('LESSON_QUIZ_PASSED', {
            courseId: props.courseId,
            moduleId: props.moduleId,
            lessonId: lessonId.value,
          })
          completeALesson(lessonId.value, resp.completionId)
        }
        router
          .push({
            name: 'LessonQuizResults',
            query: { completionId: resp.completionId },
          })
          .catch(() => {
            return
          })
      })
      .finally(() => {
        trackGamificationActivity('LESSON_QUIZ_COMPLETED', {
          courseId: props.courseId,
          moduleId: props.moduleId,
          lessonId: lessonId.value,
        })
      })
  }

  const onVideoUpload = (url: string) => {
    EditorModule.setEditableState({
      key: 'currentLessonvideoUrl',
      path: route.path,
      state: 'currentLesson',
      property: 'videoUrl',
      value: url,
    })
  }

  const onLessonDownloadableChange = (property: keyof LessonDownloadable, value: any) => {
    EditorModule.setEditableState({
      key: `lessonDownloadable${property}`,
      path: route.path,
      state: 'lessonDownloadable',
      property: property,
      value: value,
    })
  }

  const removeDownloadableAudioAuthor = () => {
    onLessonDownloadableChange('audioAuthor', null)
  }

  const addDownloadableAuthor = (authorId: string) => {
    const selectedAuthor = EditorModule.editorAllAuthors!.find((author) => author.id === authorId)
    if (selectedAuthor) {
      onLessonDownloadableChange('audioAuthor', selectedAuthor)
    }
  }

  const setDownloadableAudioUrl = (url: string) => {
    onLessonDownloadableChange('audioUrl', url)
  }

return { __sfc: true,props, route, router, quizId, completeALesson, lessonId, course, currentModule, lessonQuizCompleted, trackGamificationActivity, editorMode, currentEditorLesson, inEditorMode, quizQuestions, lessonDownloadable, downloadTeaserImageUrl, lessonDownloadableAuthorId, submitQuizAnswers, onVideoUpload, onLessonDownloadableChange, removeDownloadableAudioAuthor, addDownloadableAuthor, setDownloadableAudioUrl, computed, TextRenderer, AudioLesson, TableLesson, LessonSlideshow, AuthorAudioSection, QuestionWithButtons, LessonScript, CourseApi, useCourse, useSegment, useGamification, VideoOrImageRenderer, EditorModule, useEditor, DurationInput, VideoTranscript, LessonSlideshowEditor, AudioLessonEditor, EditDownloadableDownloadUrl, EditLessonInCourseDownloadables, AudioAuthor, useRoute, useRouter }
}

})